import * as React from 'react';
import NavBar  from './NavBarComponent'
import Presentation from './PresentationComponent';
import Portfolio from './PortfolioComponent';
import Reconhecimento from './ReconhecimentoComponent'
import Products from './ProductsComponent';
import Team from './TeamComponent';
import Contato from './ContactComponent';
import Footer from './FooterComponent';


class LandingPage extends React.Component <any, any> {
     render(){
        return(
            <div> 
                <NavBar/>
                <Presentation id="prod" name="portfolio"/>
                <Portfolio/>
                <Reconhecimento/>
                <Products/>
                <Team/>
                <Contato/>
                <Footer/>
            </div>
        );
    }
}
export default LandingPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/LandingPageComponent.tsx